

import { Injectable } from "@angular/core";
import { RequestData } from "src/app/common/models/request-data.model";
import { AmenityModel } from "./models/amenity.model";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";
@Injectable({
  providedIn: 'root'
})
export class AmenityService {
  
  constructor(private http: HttpClient) {}


  /**
   *
   * @param amenityInfo
   * Calls the API to delete the record
   */
  delete(amenityInfo: AmenityModel): Observable<any> {
    return this.http.get(environment.baseUrl + "amenity/delete?id=" + amenityInfo.id);

  }
  getAmenityList(): any {
    return this.http.get<any>(environment.baseUrl + "amenity/get-list");
  }
  // getAmenityListExt(staticPayload: { search: { filters: { filter: never[]; scope: { offset: string; limit: number; }; }; sort: { column: string; order: string; }[]; }; }): Observable<any> {
  //   return this.http.post<Response>(
  //     environment.baseUrl + "amenity/get-list-ext",
  //     staticPayload
  //   );
  // }
  getAmenityListExt(requestData:RequestData): Observable<any> {

   
    return this.http.post(environment.wsPhp+'/amenity/get-list', requestData);
  
}


  getId(id: number): Observable<any> {
    return this.http.get(environment.baseUrl + "amenity/get?id=" + id);
    
  }
  /**
   *
   * @param userInfo
   * Calls the update API to insert/update the record
   */
  update(requestParams: any) {
    return this.http.post(
      environment.baseUrl + "amenity/save",
      requestParams
    );
  }
  downloadExcel(requestData: any): Observable<Blob> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
   // const url = 'http://yourdomain.com/api/customers/export'; // Adjust URL

    return this.http.post(environment.wsPhp + '/amenity/export', requestData, { headers, responseType: 'blob' })
      .pipe(
        //catchError(this.handleError)
      );

  }

}

